var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{staticClass:"badged mr-4",attrs:{"bordered":"","bottom":"","right":"","overlap":"","color":"error","icon":_vm.icon}},[_c('v-avatar',{attrs:{"size":"40"}},[_c('v-img',{attrs:{"src":_vm.src}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }